export const isOrgInn = (inn: string) => {
  const multiplied = [2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
  const innNumbers = inn.split("").map((num) => Number(num));
  const sumOfProducts = multiplied.reduce((acc, inn, index) => acc + inn * innNumbers[index], 0);
  const lastInnNumber = innNumbers[innNumbers.length - 1];
  return sumOfProducts % 11 === lastInnNumber || "Некорректный ИНН";
};
